<svelte:head>
  <title>Пайдалану шарттары — Zetix</title>
  <meta name="description" content="Zetix платформасын пайдалану шарттары мен ережелері." />
</svelte:head>

<article class="mx-auto max-w-3xl px-4 py-12 prose prose-slate">
  <h1>Пайдалану шарттары</h1>
  <p><em>Соңғы жаңарту: 2026-04-21</em></p>

  <h2>1. Қызметті пайдалану</h2>
  <p>
    Zetix платформасын пайдалану арқылы сіз төмендегі шарттармен келісесіз.
    Келіспеген жағдайда, қызметті пайдалануды тоқтатуыңызды сұраймыз.
  </p>

  <h2>2. Есептік жазба</h2>
  <p>
    Есептік жазба жасаған кезде сіз ұсынған ақпараттың дәлдігіне жауап бересіз.
    Құпия сөзді сақтау — сіздің жауапкершілігіңіз.
  </p>

  <h2>3. Материалдардың авторлық құқығы</h2>
  <p>
    Платформадағы оқулықтар мен материалдар олардың тиісті иелеріне тиесілі.
    Zetix оларды білім беру мақсатында ғана ұсынады.
  </p>

  <h2>4. Тыйым салынған әрекеттер</h2>
  <ul>
    <li>Автоматтандырылған жинау құралдарын пайдалану</li>
    <li>Басқа пайдаланушыларға зиян келтіру</li>
    <li>Платформаның тұрақтылығына қауіп төндіру</li>
  </ul>

  <h2>5. Жауапкершілікті шектеу</h2>
  <p>
    Платформа «ол қандай болса, сондай» негізде ұсынылады. Қызметтің үзіліссіз
    жұмысына кепілдік берілмейді.
  </p>
</article>
